import swal from "sweetalert";
import I18n from "../../i18n";
import { EStatusEndQuiz, IQuestion, IRecordItem, IRecordObj, TArrayQuestion, TRecordCollection } from "../../interfaces/quiz";
import CtrlBase from "../abstracts/ctrlBase";
import questions from "./questions/questions";
import finalQuiz from "./templates/finalQuiz";
import initialPage from "./templates/initialPage";
import question from "./templates/question";
import ranking from "./templates/ranking";
import timer from "./templates/timer";

export default class QuizCtrl extends CtrlBase{
    private btnRanking:HTMLButtonElement;
    private dropdownModeContainer:HTMLElement;
    private containerCurrentModeSelect:HTMLElement;
    private containerQuizPlay:HTMLElement;
    private btnPlay:HTMLButtonElement;
    private btnBack:HTMLButtonElement;
    private btnPlayAgain:HTMLButtonElement;
    private quizMode:string = "classic";
    private arrayQuestions:TArrayQuestion;
    private currentQuestionObj:IQuestion;
    private totalScore:number = 0;
    private correctAnswer:number;
    private questionPast:number[] = [];
    private currentTime:number = 15;
    private idTimeInterval:any;
    private timerProgress:HTMLDivElement;
    private timerCounter:HTMLSpanElement;

    constructor(protected parentElement:HTMLElement){
        super(parentElement);
    }

    public rederInitialPage(){
        this.questionPast.length = 0;
        this.totalScore = 0;
        this.renderPage(initialPage);
        this.eventsOnInitialPage();
    }

    private rederPlayPage(){
        this.arrayQuestions = questions[I18n.lang()];
        this.totalScore = 0;
        this.generateQuestion();
    }

    private generateQuestion(){
        this.clearTimeInterval();
        this.currentQuestionObj = this.arrayQuestions[this.generateIdQuestion()];
        this.correctAnswer = this.currentQuestionObj.correct;
        let {theme,question:questionTex,answer,image} = this.currentQuestionObj;
        this.renderPage(()=>question(theme,questionTex,answer,image));
        this.renderTimer();
        this.containerQuizPlay = this.parentElement.querySelector("#quiz-play");
        this.eventAnswerQuestion();
        this.addEventBack();
        this.contTimeInterval();
    }

    private contTimeInterval(){
        if(this.quizMode=="15sec"){
            this.timerProgress.classList.add("anime");
            this.idTimeInterval = setInterval(()=>{
                this.currentTime--;
                if(this.currentTime==0)this.renderPageFinal(EStatusEndQuiz.timeEnd);
                this.updateTimer();
            },1000);
        }
    }

    private clearTimeInterval(){
        if(this.quizMode=="15sec"){
            this.currentTime = 15;
            clearInterval(this.idTimeInterval);
        }
    }

    private renderTimer(){
        if(this.quizMode=="15sec"){
            this.parentElement.insertAdjacentHTML("afterbegin",timer(this.currentTime));
            this.timerCounter = this.parentElement.querySelector("#quiz-timer .timer-second");
            this.timerProgress = this.parentElement.querySelector("#quiz-timer .timer-progress");

            this.timerProgress.classList.remove("anime");
        }
    }

    private updateTimer(){
        this.timerCounter.innerText = `${this.currentTime}.Sec`;
    }

    private generateIdQuestion():number{
        let idQuestion:number;
        if(this.questionPast.length===0){
            idQuestion = Math.floor(Math.random() * this.arrayQuestions.length);
        }else{
            do{
                idQuestion = Math.floor(Math.random() * this.arrayQuestions.length);
            }while(this.questionPast.includes(idQuestion));
        }

        this.questionPast.push(idQuestion);
        return idQuestion;
    }

    private addEventBack(){
        this.btnBack = this.parentElement.querySelector(".btn-back");
        this.btnBack.addEventListener("click",()=>{
            this.clearTimeInterval();
            this.quizMode = "classic";
            this.rederInitialPage();
        });
    }

    private addEventPlayAgain(){
        this.btnPlayAgain = this.parentElement.querySelector(".btn-again");
        this.btnPlayAgain.addEventListener("click",()=>{
            this.questionPast.length = 0;
            this.rederPlayPage();
        });
    }

    private eventsOnInitialPage(){
        this.getElementInitialPage();

        this.dropdownModeContainer.addEventListener("click",(e)=>{
            this.toggleDropdown(e);
        });

        this.btnPlay.addEventListener("click",()=>{
            this.rederPlayPage();
        });

        this.btnRanking.addEventListener("click",()=>{
            this.rederPageRanking("classic");
        });

    }

    private eventAnswerQuestion(){
        let optionItem = this.containerQuizPlay.querySelectorAll<HTMLElement>(".option-item");
        let answerFeedback = this.containerQuizPlay.querySelector(".quiz-feedback");
        optionItem.forEach(alternative=>{
            alternative.addEventListener("click",()=>{
                /*if(+alternative.dataset.ansCode===this.correctAnswer){
                    this.addScore();
                    if(this.questionPast.length === this.arrayQuestions.length){
                        this.renderPageFinal(EStatusEndQuiz.noQuestion);
                    }else{
                        this.generateQuestion();
                    }
                }else{
                    this.renderPageFinal(EStatusEndQuiz.gameOver);
                }*/
                optionItem.forEach(item=>{
                    item.classList.remove("selected");
                    item.classList.remove("correct");
                    item.classList.remove("wrong");
                });
                alternative.classList.add("selected");
                swal({
                    title: "Confirmar resposta",
                    text: "",
                    buttons: ["mudar", "confirmar"],
                    dangerMode: false,
                })
                .then((willDelete) => {
                    if (willDelete) {
                        answerFeedback.innerHTML = "";
                        answerFeedback.classList.remove("correct");
                        answerFeedback.classList.remove("incorrect");
                        if(+alternative.dataset.ansCode===this.correctAnswer){
                            this.addScore();
                            answerFeedback.classList.add("correct");
                            alternative.classList.add("correct");
                            answerFeedback.innerHTML = "Resposta correta";
                            //swal("Resposta certa", "parabéns a resposta está correta", "success");
                        }else{
                            //alert("Resposta errada");

                            let correctAlternative = this.containerQuizPlay.querySelector(`[data-ans-code="${this.correctAnswer}"]`);
                            
                            let correctResponse = this.currentQuestionObj.answer.find(answer=>{
                                if(+answer.ansCode===this.correctAnswer)return answer.text;
                            });
                            alternative.classList.add("wrong");
                            answerFeedback.classList.add("incorrect");
                            correctAlternative.classList.add("correct");
                            answerFeedback.innerHTML = `Resposta errada`;
                        }
                        setTimeout(()=>{
                            answerFeedback.innerHTML = "";
                            if(this.questionPast.length === this.arrayQuestions.length){
                                //clearTimeout(clearFeedback);
                                this.renderPageFinal(EStatusEndQuiz.noQuestion);
                            }else{
                                this.generateQuestion();
                            }
                        },2000);
 
                    }
                });
                
            });
        });
    }

    private renderPageFinal(status:EStatusEndQuiz){
        let objRecord:IRecordObj = this.checkRecord();
        this.renderPage(()=>finalQuiz(status,objRecord));
        this.clearTimeInterval();
        this.addEventBack();
        this.addEventPlayAgain();
        this.addEventRegRecord(objRecord);
    }

    private rederPageRanking(rankingToShow:string){
        let objRecordLocalStorage = JSON.parse(localStorage.getItem(rankingToShow)) as TRecordCollection??[];
        this.renderPage(()=>ranking(objRecordLocalStorage,rankingToShow));
        this.addEventBack();
        this.addEventSwitchRanking();
    }

    private addScore(){
        if(this.quizMode=="classic"){
            this.totalScore += 10;
        }

        if(this.quizMode=="15sec"){
            this.totalScore += (10 + this.currentTime);
        }
    }

    private checkRecord():IRecordObj{
        let objRecord:IRecordObj;

        let objRecordLocalStorage = JSON.parse(localStorage.getItem(this.quizMode)) as TRecordCollection??[];
        if(objRecordLocalStorage.length==0 && this.totalScore>0){
            objRecord = {
                status:true,
                place:1,
                points:this.totalScore
            };
        }else{
            let lastRecord = objRecordLocalStorage.findIndex((record)=>{
                return record.score<=this.totalScore && new Date(record.date).getTime()<=new Date().getTime();
            });
            if(lastRecord>-1){
                objRecord = {
                    status:true,
                    place:lastRecord+1,
                    points:this.totalScore
                }
            }else{
                if(objRecordLocalStorage.length<=5 && this.totalScore>0){
                    objRecord = {
                        status:true,
                        place:objRecordLocalStorage.length+1,
                        points:this.totalScore
                    }
                }else{
                    objRecord = {
                        status:false,
                        points:this.totalScore
                    }
                }
            }
        }

        return objRecord;
    }

    private addEventSwitchRanking(){
        let btnSwitch = this.parentElement.querySelector(".btn-switch:not(.active)") as HTMLButtonElement;
        let rankingToShow = btnSwitch.dataset.ranking;

        btnSwitch.addEventListener("click",()=>{
            this.rederPageRanking(rankingToShow);
        });
    }

    private addEventRegRecord(objRecord:IRecordObj){
        if(objRecord.status){
            let inputUserName = this.parentElement.querySelector("#name-player") as HTMLInputElement;
            let btnSaveRecord =  this.parentElement.querySelector(".sav-record") as HTMLButtonElement;

            inputUserName.addEventListener("keyup",()=>{
                if(inputUserName.value!==""){
                    btnSaveRecord.removeAttribute("disabled")
                }else{
                    btnSaveRecord.setAttribute("disabled","disabled")
                }
            });

            btnSaveRecord.addEventListener("click",()=>{
                if(inputUserName.value===""){
                    alert(I18n.translate("Por favor degite seu nome"));
                }else{
                    let objRecordLocalStorage = JSON.parse(localStorage.getItem(this.quizMode)) as TRecordCollection??[];
                    let newObjRecord:IRecordItem = {
                        user:inputUserName.value.trim(),
                        score:this.totalScore,
                        date:new Date()
                    }
                    if(objRecordLocalStorage.length==0){
                        objRecordLocalStorage.push(newObjRecord)
                    }else{
                        objRecordLocalStorage.splice(objRecord.place-1,0,newObjRecord);
                        if(objRecordLocalStorage.length>=6){
                            objRecordLocalStorage.pop();
                        }
                    }

                    localStorage.setItem(this.quizMode,JSON.stringify(objRecordLocalStorage));
                    this.rederPageRanking(this.quizMode)
                    this.quizMode = "classic";
                }
            });
        }
    }

    private getElementInitialPage(){
        this.btnRanking = this.parentElement.querySelector(".btn-raking") as HTMLButtonElement;
        this.dropdownModeContainer = this.parentElement.querySelector(".dropdown-mode") as HTMLElement;
        this.btnPlay = this.parentElement.querySelector(".btn-play") as HTMLButtonElement;
        this.containerCurrentModeSelect = this.dropdownModeContainer.querySelector(".current") as HTMLElement;
    }

    private toggleDropdown(e:Event){
        let innerElementCliked = e.target as HTMLElement;
        let elementOptionSpan: HTMLSpanElement;

        this.dropdownModeContainer.querySelector(".options").classList.toggle("d-none");

        this.selectQuizMode(innerElementCliked,elementOptionSpan);
    }

    private selectQuizMode(innerElementCliked:HTMLElement,elementOptionSpan:HTMLSpanElement){
        if(innerElementCliked.classList.contains("item-option")){
            elementOptionSpan = innerElementCliked.closest(".option-item")
        }else if(innerElementCliked.classList.contains("option-item")){
            elementOptionSpan = innerElementCliked
        }

        if(elementOptionSpan){
            this.quizMode = elementOptionSpan.dataset.quizMode;
            this.containerCurrentModeSelect.innerHTML = elementOptionSpan.innerHTML
        }
    }
}